<div class="wrapper">
  <div class="row justify-content-center">
      <div class="col-lg-6" *ngIf="token">

        <div class="card-box">
          <h4 class="header-title">Confirm Account</h4>
          <p class="sub-header">
            Confirm account details
          </p>

          <div class="form-group">
            <label for="emailaddress">Email address</label>
            <input [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="form-control" type="email" id="emailaddress" required="" placeholder="Enter your email">
          </div>

          <div class="form-group">
            <label for="passWord1">Password<span class="text-danger">*</span></label>
            <input [formControl]="password" id="passWord1" type="password" placeholder="Enter your password" required class="form-control">

            <ul *ngIf="submitted || password.touched" class="parsley-errors-list filled">
              <li *ngIf="password.hasError('required')" class="parsley-required">This value is required.</li>
              <li *ngIf="password.hasError('minLength')" class="parsley-required">Password must be atlease 8 characters.</li>
              <li *ngIf="password.hasError('pattern')" class="parsley-required">Password requres 1 Capital, 1 Number and a special character</li>
            </ul>

          </div>
          <div class="form-group">
            <label for="passWord2">Confirm Password <span class="text-danger">*</span></label>
            <input [formControl]="confirmPassword" type="password" required placeholder="Enter your password" class="form-control" id="passWord2">
            <ul *ngIf="submitted || confirmPassword.touched" class="parsley-errors-list filled">
              <li *ngIf="confirmPassword.hasError('required')" class="parsley-required">This value is required.</li>
              <li *ngIf="confirmPassword.hasError('passwordsMatch')" class="parsley-required">Passwords do not match</li>
            </ul>
          </div>

            <div class="form-group text-right mb-0">
              <button (click)="confirm()" class="btn btn-gradient waves-effect waves-light" type="submit">Confirm</button>
            </div>

        </div> <!-- end card-box -->
      </div>
  </div>
</div>
